export default __webpack_public_path__ + "static/media/BG.eaa7efa2.png";